import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import LockIcon from '@material-ui/icons/CloudDone'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { loginUser, verifyMfaCode } from '../../api/authApi'
import { required } from '../../utils/validationUtils'

const styles = theme => ({
    root: {
        flexGrow: 1,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.primary.main
    },

    formControl: {
        margin: theme.spacing.unit
    },

    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2
    },

    form: {
        padding: '0 1em 1em 1em'
    },
    input: {
        marginTop: '1em'
    },
    actions: {
        padding: '0 1em 1em 1em'
    },
    card: {
        maxWidth: '90%',
        width: '450px',
        minWidth: 250,
        marginLeft: '1em',
        marginRight: '1em',
        marginBottom: '3em'
    },
    avatar: {
        margin: '1em',
        display: 'flex',
        justifyContent: 'center'
    },
    icon: {
        backgroundColor: theme.palette.secondary.main
    },
    hint: {
        marginTop: '1em',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: theme.palette.grey[800]
    },
    experimentalText: {
        color: theme.palette.error.main
    },
    backButton: {
        marginTop: '1em'
    }
})

class LoginPage extends Component {
    static propTypes = {
        classes: PropTypes.object,
        loginUser: PropTypes.func.isRequired,
        verifyMfaCode: PropTypes.func.isRequired
    }

    state = {
        email: '',
        password: '',
        mfaCode: '',
        emailError: false,
        passwordError: false,
        mfaCodeError: false,
        showMfaInput: false,
        mfaToken: null
    }

    handleChange = e => {
        const { name, value } = e.target

        if (name === 'mfaCode') {
            if (value === '' || /^[0-9\b]+$/.test(value)) {
                this.setState({ [name]: value })
            }
            return
        }

        this.setState({ [name]: value })
    }

    handleSubmit = e => {
        e.preventDefault()

        const { email, password } = this.state

        const emailError = required(email)
        const passwordError = required(password)

        if (!emailError && !passwordError) {
            this.props
                .loginUser(email, password)
                .then(() => {
                    // Login successful, redirect happens in authApi
                })
                .catch(error => {
                    // Check if MFA is required
                    if (error.mfaRequired && error.mfaToken) {
                        this.setState({
                            showMfaInput: true,
                            mfaToken: error.mfaToken,
                            mfaCode: '',
                            mfaCodeError: false,
                            emailError: false,
                            passwordError: false
                        })
                    } else {
                        this.setState({ emailError, passwordError })
                    }
                })
        } else {
            this.setState({ emailError, passwordError })
        }
    }

    handleMfaSubmit = e => {
        e.preventDefault()

        const { mfaCode, mfaToken } = this.state

        const mfaCodeError = required(mfaCode)

        if (!mfaCodeError && mfaToken) {
            this.props.verifyMfaCode(mfaCode, mfaToken).catch(() => {
                this.setState({
                    mfaCodeError: 'Неправильний код. Спробуйте ще раз.'
                })
            })
        } else {
            this.setState({ mfaCodeError })
        }
    }

    handleBackToLogin = () => {
        this.setState({
            showMfaInput: false,
            mfaToken: null,
            mfaCode: '',
            mfaCodeError: false
        })
    }

    renderLoginForm() {
        const { classes } = this.props
        const { email, password, emailError, passwordError } = this.state

        return (
            <form onSubmit={this.handleSubmit} noValidate>
                <div className={classes.hint}>
                    <Typography variant="title">EasyMS Channel Manager</Typography>
                </div>

                <div className={classes.form}>
                    <div className={classes.input}>
                        <TextField
                            type="email"
                            label="e-mail"
                            name="email"
                            value={email}
                            fullWidth
                            onChange={this.handleChange}
                            error={!!emailError}
                            helperText={emailError}
                        />
                    </div>
                    <div className={classes.input}>
                        <TextField
                            label="Пароль"
                            type="password"
                            name="password"
                            value={password}
                            fullWidth
                            onChange={this.handleChange}
                            error={!!passwordError}
                            helperText={passwordError}
                        />
                    </div>
                </div>
                <CardActions className={classes.actions}>
                    <Button
                        role="button"
                        aria-label="Увійти"
                        variant="raised"
                        color="primary"
                        className={classes.button}
                        fullWidth
                        type="submit"
                    >
                        Увійти
                    </Button>
                </CardActions>
            </form>
        )
    }

    renderMfaForm() {
        const { classes } = this.props
        const { mfaCode, mfaCodeError } = this.state

        return (
            <form onSubmit={this.handleMfaSubmit} noValidate>
                <div className={classes.hint}>
                    <Typography variant="title">Двухфакторна автентифікація</Typography>
                    <Typography variant="body1" style={{ marginTop: '0.5em', textAlign: 'center' }}>
                        Введіть 6-значний код із застосунку-автентифікатора
                    </Typography>
                </div>

                <div className={classes.form}>
                    <div className={classes.input}>
                        <TextField
                            type="text"
                            label="Код MFA"
                            name="mfaCode"
                            value={mfaCode}
                            fullWidth
                            onChange={this.handleChange}
                            error={!!mfaCodeError}
                            helperText={mfaCodeError}
                            inputProps={{
                                maxLength: 6,
                                inputMode: 'numeric',
                                pattern: '[0-9]*'
                            }}
                            autoFocus
                        />
                    </div>
                </div>
                <CardActions className={classes.actions}>
                    <Button
                        role="button"
                        aria-label="Підтвердити"
                        variant="raised"
                        color="primary"
                        className={classes.button}
                        fullWidth
                        type="submit"
                    >
                        Підтвердити
                    </Button>
                </CardActions>
                <CardActions className={classes.actions}>
                    <Button
                        role="button"
                        aria-label="Назад"
                        variant="outlined"
                        className={classes.backButton}
                        fullWidth
                        onClick={this.handleBackToLogin}
                    >
                        Назад
                    </Button>
                </CardActions>
            </form>
        )
    }

    render() {
        const { classes } = this.props
        const { showMfaInput } = this.state

        return (
            <div className={classes.root}>
                <Card className={classes.card}>
                    <div className={classes.avatar}>
                        <Avatar className={classes.icon}>
                            <LockIcon />
                        </Avatar>
                    </div>

                    {showMfaInput ? this.renderMfaForm() : this.renderLoginForm()}
                </Card>
            </div>
        )
    }
}

export default connect(
    null,
    { loginUser, verifyMfaCode }
)(withStyles(styles)(LoginPage))



// WEBPACK FOOTER //
// ./src/components/LoginPage/LoginPage.js